export default __webpack_public_path__ + "media/images/images/banner/banner-12-3bf1dcd0e60842b9068356f19091e5ef.jpg";